"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateWithUSAIdx = exports.stateIdx = exports.USGrid = exports.statesGrid = void 0;
const lodash_1 = __importDefault(require("lodash"));
const usStates_1 = __importDefault(require("../../utilities/usStates"));
exports.statesGrid = [[1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1], [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0], [0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0], [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0], [1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0]];
exports.USGrid = [[1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0], [0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0], [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0], [0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0], [1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0]];
const statesWithUSA = [usStates_1.default[0], {
  abbr: 'US',
  name: 'US',
  fips: 'US'
}, ...usStates_1.default.slice(1)];
const stateIdx = grid => {
  const coords = (0, lodash_1.default)(grid).flatMap((d, i) => d.map((e, j) => e ? [i, j] : null)).filter(d => d).value();
  return coords.map((_ref, idx) => {
    let [i, j] = _ref;
    return {
      i,
      j,
      properties: usStates_1.default[idx]
    };
  });
};
exports.stateIdx = stateIdx;
const stateWithUSAIdx = grid => {
  const coords = (0, lodash_1.default)(grid).flatMap((d, i) => d.map((e, j) => e ? [i, j] : null)).filter(d => d).value();
  return coords.map((_ref2, idx) => {
    let [i, j] = _ref2;
    return {
      i,
      j,
      properties: statesWithUSA[idx]
    };
  });
};
exports.stateWithUSAIdx = stateWithUSAIdx;